import React from "react";
import GreatJob from "../../../../assets/svgs/gameplay/GreatJob";
import { getWidth } from "../../../../utils/relativeSizes";
import CommonAnimation from "./CommonAnimation";

const GreatJobAnimation = () => {

  return (
    <CommonAnimation>
      <GreatJob width={getWidth(107)} height={getWidth(61)} />
    </CommonAnimation>
  );
};

export default GreatJobAnimation;
